import './ProductSection.scss';

import ApplianceSingle from './ApplianceSingle';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ProductSection(props: any) {
    const { elements, isDiscontinued = false } = props;
    const { t } = useTranslation('pages');

    return (
        <div
            className={
                isDiscontinued ? 'discontinued-section' : 'product-section'
            }
        >
            <h2>
                {isDiscontinued
                    ? t('search.discontinued-products')
                    : t('search.products')}
            </h2>
            <div className='product-grid'>
                {elements.map((product: any, index: number) => {
                    return (
                        <ApplianceSingle
                            appliance={product}
                            key={
                                isDiscontinued
                                    ? `discontinued-appliance-${index}`
                                    : `active-appliance-${index}`
                            }
                            isDiscontinued={product?.slug?.['en_CA']?.includes(
                                'discontinued'
                            )}
                        />
                    );
                })}
            </div>
        </div>
    );
}
